var _jsxFileName = "/repo/packages/webassets/src/components/Header/components/MomentiveHeaderLogo/MomentiveHeaderLogo.tsx",
  _this2 = this;
import React from 'react';
import { useTheme } from 'react-jss';
import { Box } from '@wds/box';
import { TabletScreen, MobileScreen } from '../../../MediaComponents';
import MomentiveLogoType from './MomentiveLogoType';
import MomentiveLogoMark from './MomentiveLogoMark';
import useStyles from './useStyles';
function withHeaderLink(Component) {
  var _this = this;
  return function (props) {
    var isUserAuthenticated = props.isUserAuthenticated;
    var theme = useTheme();
    var classes = useStyles({
      isUserAuthenticated: isUserAuthenticated,
      theme: theme
    });
    return /*#__PURE__*/React.createElement(Box, {
      className: classes.headerBox,
      display: "flex",
      flexAlign: "center",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 24,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: "/",
      "aria-label": "Momentive Logo",
      className: classes.headerLink,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.headerLogo,
      display: "flex",
      flexAlign: "center",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 13
      }
    })))));
  };
}
var MomentiveIcons = function MomentiveIcons(_ref) {
  var isContrast = _ref.isContrast,
    _ref$showTypography = _ref.showTypography,
    showTypography = _ref$showTypography === void 0 ? false : _ref$showTypography;
  var theme = useTheme();
  var typeColor = isContrast ? theme.palette.text.dark : theme.palette.text.light;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 5
    }
  }, showTypography && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    pr: 1,
    flexAlign: "flex-end",
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(MomentiveLogoType, {
    fill: typeColor,
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexAlign: "flex-end",
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(MomentiveLogoMark, {
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 9
    }
  })));
};
var MomentiveLogo = function MomentiveLogo(_ref2) {
  var isUserAuthenticated = _ref2.isUserAuthenticated,
    isContrast = _ref2.isContrast;
  if (!isUserAuthenticated) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabletScreen, {
      __self: _this2,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 67,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(MomentiveIcons, {
      isContrast: isContrast,
      showTypography: true,
      __self: _this2,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 11
      }
    })), /*#__PURE__*/React.createElement(MobileScreen, {
      __self: _this2,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(MomentiveIcons, {
      isContrast: isContrast,
      __self: _this2,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71,
        columnNumber: 11
      }
    })));
  }
  return /*#__PURE__*/React.createElement(MomentiveIcons, {
    isContrast: isContrast,
    showTypography: true,
    __self: _this2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 10
    }
  });
};
export default withHeaderLink(MomentiveLogo);
//# sourceMappingURL=MomentiveHeaderLogo.js.map